import { render, staticRenderFns } from "./ModalContentMemberReject.vue?vue&type=template&id=0c5cdf0c&scoped=true&"
import script from "./ModalContentMemberReject.vue?vue&type=script&lang=js&"
export * from "./ModalContentMemberReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5cdf0c",
  null
  
)

export default component.exports